import * as z from "zod";
import { outboundWeightByZoneSchema } from "./rate-table";
import { RateTableCarrier } from "./rate-table-mapping";

export const CarriersToQuote = z.enum([
  RateTableCarrier.USPS,
  RateTableCarrier.UPS,
  RateTableCarrier.UPS_SUREPOST,
  RateTableCarrier.FEDEX,
  RateTableCarrier.DHL_ECS,
  RateTableCarrier.Amazon,
  RateTableCarrier.UNIUNI,
]);

const carrierRateTablesSchema_ = z.object({
  fetchedAt: z.string(),
  rateTables: z.partialRecord(
    CarriersToQuote,
    z.array(outboundWeightByZoneSchema),
  ),
});

export const carrierRateTablesSchema: z.ZodType<RedoCarrierRateTables> =
  carrierRateTablesSchema_;
export interface RedoCarrierRateTables
  extends z.infer<typeof carrierRateTablesSchema_> {}

export const CARRIER_RATE_TABLES_KEY = "CARRIER_RATE_TABLES";
